import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import { formatTimeSeriesByDay, formatTimeSeriesByMonth } from '@/helpers/dateTime';
import apiService from '@/services/ApiService';

const statsApi = createApi({
  reducerPath: 'statsApi',
  baseQuery: fetchBaseQuery({ baseUrl: '/' }),
  endpoints: (builder) => ({
    getGraphData: builder.query<
      any,
      {
        campaign_uid: number | undefined;
        uid: number;
        startDate: string;
        endDate: string;
        interval: string;
        stat_types?: string;
      }
    >({
      queryFn: async ({ campaign_uid, uid, startDate, endDate, interval, stat_types }) => {
        try {
          const data = await apiService.getStatsMetrics(campaign_uid, uid, startDate, endDate, interval, stat_types);
          if (interval === 'months') {
            return { data: formatTimeSeriesByMonth(data) };
          }
          return { data: formatTimeSeriesByDay(data) };
        } catch (error: any) {
          return { error };
        }
      },
    }),
  }),
});

export default statsApi;

export const { useLazyGetGraphDataQuery } = statsApi;
